module.exports = __webpack_public_path__ + "static/media/29-verdt.21e5a909.mp3";